import type { RouteRecordRaw } from 'vue-router'

export const devicesRoutes: RouteRecordRaw[] = [
  {
    path: '/devices',
    name: 'devices',
    component: () => import('./pages/DevicesPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/devices/:id',
    name: 'device-detail',
    component: () => import('./pages/DeviceDetailsPage.vue'),
    meta: { requiresAuth: true },
  },
]
